module.exports = __webpack_public_path__ + "static/childcouncil_council@2x-e8bae732275a8bcf5250a451c15b00ca.png";